import actions from '../../actions/VisionBenefitsSets'
import { connectPlanSharedBusinessRules } from '../PlanSharedBusinessRules/CreateBusinessRulesShow'

export default connectPlanSharedBusinessRules('Vision', actions.show.main, actions.show.reset)
